import './model-single-feedback.scss';

/**
 * Zelfde patroon als reviews-switcher: kliks op .uk-subnav wisselen .uk-active op
 * .uk-switcher en de dot-nav, zonder jQuery UIkit.
 */
( function() {

	const ROOT = '.tm-model-single-feedback';
	const ACTIVE = 'uk-active';
	const RESIZE_DEBOUNCE_MS = 150;
	const FEEDBACK_CAROUSEL_ROOT = '.js-modelSingleFeedbackCarousel';

	const debounce = ( fn, delay ) => {
		let t = null;
		return ( ...args ) => {
			window.clearTimeout( t );
			t = window.setTimeout( () => fn( ...args ), delay );
		};
	};

	const refreshActivePanelLayout = ( switcher ) => {
		const active = switcher.querySelector( ':scope > .' + ACTIVE );
		if ( ! active ) {
			return;
		}
		void active.offsetHeight;
	};

	const setIndex = ( switcher, subnav, index ) => {
		const panes = switcher.querySelectorAll( ':scope > li' );
		const tabs  = subnav.querySelectorAll( ':scope > li' );
		if ( index < 0 || index >= panes.length || index >= tabs.length ) {
			return;
		}
		panes.forEach( ( li, i ) => li.classList.toggle( ACTIVE, i === index ) );
		tabs.forEach( ( li, i ) => li.classList.toggle( ACTIVE, i === index ) );
		refreshActivePanelLayout( switcher );
	};

	const initBlock = ( root ) => {
		if ( ! root || root.dataset.modelSingleFeedbackInit === '1' ) {
			return;
		}

		const subnav = root.querySelector( '.uk-subnav' );
		if ( ! subnav ) {
			return;
		}

		const switcher = subnav.previousElementSibling;
		if ( ! switcher || ! switcher.classList.contains( 'uk-switcher' ) ) {
			return;
		}

		const panes = switcher.querySelectorAll( ':scope > li' );
		const tabs  = subnav.querySelectorAll( ':scope > li' );
		if ( panes.length === 0 || tabs.length === 0 || panes.length !== tabs.length ) {
			return;
		}

		root.dataset.modelSingleFeedbackInit = '1';

		subnav.addEventListener( 'click', ( event ) => {
			const link = event.target.closest( 'a' );
			if ( ! link || ! subnav.contains( link ) ) {
				return;
			}
			event.preventDefault();

			const tabLi = link.closest( 'li' );
			if ( ! tabLi || ! subnav.contains( tabLi ) ) {
				return;
			}

			const index = Array.prototype.indexOf.call( tabs, tabLi );
			if ( index === -1 ) {
				return;
			}

			setIndex( switcher, subnav, index );
		} );

		const onResize = debounce( () => {
			refreshActivePanelLayout( switcher );
		}, RESIZE_DEBOUNCE_MS );

		window.addEventListener( 'resize', onResize, { passive: true } );
		window.addEventListener( 'orientationchange', onResize, { passive: true } );
	};

	const initFeedbackCarousel = ( root ) => {
		if ( ! root || root.dataset.modelSingleFeedbackCarouselInit === '1' ) {
			return;
		}

		const viewport = root.querySelector( '.b-modelSingle__feedbackViewport' );
		const track = root.querySelector( '.b-modelSingle__feedbackTrack' );
		const prev = root.querySelector( '[data-feedback-dir="prev"]' );
		const next = root.querySelector( '[data-feedback-dir="next"]' );

		if ( ! viewport || ! track ) {
			return;
		}

		const slides = Array.from( track.children );
		if ( slides.length <= 1 ) {
			return;
		}

		root.dataset.modelSingleFeedbackCarouselInit = '1';

		let index = 0;

		const clamp = ( value, min, max ) => Math.min( Math.max( value, min ), max );

		const visibleCount = () => {
			const first = slides[ 0 ];
			if ( ! first ) {
				return 1;
			}
			const firstWidth = first.getBoundingClientRect().width;
			if ( firstWidth <= 0 ) {
				return 1;
			}
			const style = window.getComputedStyle( track );
			const gap = parseFloat( style.columnGap || style.gap || '0' ) || 0;
			return Math.max( 1, Math.round( ( viewport.clientWidth + gap ) / ( firstWidth + gap ) ) );
		};

		const maxIndex = () => Math.max( 0, slides.length - visibleCount() );

		const translateForIndex = ( targetIndex ) => {
			if ( ! slides[ targetIndex ] ) {
				return 0;
			}
			const firstOffset = slides[ 0 ].offsetLeft;
			return -( slides[ targetIndex ].offsetLeft - firstOffset );
		};

		const updateNav = () => {
			if ( prev ) {
				prev.disabled = index <= 0;
			}
			if ( next ) {
				next.disabled = index >= maxIndex();
			}
		};

		const apply = ( animate = true ) => {
			index = clamp( index, 0, maxIndex() );
			track.style.transition = animate ? 'transform 0.35s ease' : 'none';
			track.style.transform = `translate3d(${ translateForIndex( index ) }px, 0, 0)`;
			updateNav();
		};

		if ( prev ) {
			prev.addEventListener( 'click', () => {
				index -= 1;
				apply( true );
			} );
		}

		if ( next ) {
			next.addEventListener( 'click', () => {
				index += 1;
				apply( true );
			} );
		}

		const ro = new ResizeObserver( () => apply( false ) );
		ro.observe( viewport );
		apply( false );
	};

	const init = () => {
		document.querySelectorAll( ROOT ).forEach( initBlock );
		document.querySelectorAll( FEEDBACK_CAROUSEL_ROOT ).forEach( initFeedbackCarousel );
	};

	if ( document.readyState === 'loading' ) {
		document.addEventListener( 'DOMContentLoaded', init );
	} else {
		init();
	}

} )();
